<template>
  <v-flex>
    <v-layout row class="content-header">
      <v-flex md4 class="content-title">
        <h2>Acompanhamento Online</h2>
        <h4>Confira os status de forma online de cada abertura de sinistro.</h4>
      </v-flex>
      <v-flex md3>
        <v-text-field
          v-model="search"
          label="Pesquisa"
          outlined
          placeholder="Nome, CPF, Apólice, Aviso ou Cobertura"
          class="input-pesquisa"
          @keyup.enter="pesquisar()"
        ></v-text-field>
      </v-flex>
      <v-flex md1>
        &nbsp;<v-btn color="info" style="margin-left: 5px" @click="pesquisar()"
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
      </v-flex>
      <v-flex md2>
        &nbsp;<v-btn color="info" @click="requestSinistros()">Listar Sinistros</v-btn>
      </v-flex>
      <v-flex md2>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <form :action="`${urlPostSalesForce}`" method="POST">
              <v-text-field
                style="display: none"
                label="SAMLResponse"
                name="SAMLResponse"
                id="SAMLResponse"
                v-model="samlResponseAvisoSinistro"
                outlined
              ></v-text-field>
              <v-btn
                v-on="on"
                v-bind="attrs"
                color="info"
                type="submit"
                id="btnLoginAvisoSinistroSF"
                ><v-icon>check</v-icon>&nbsp; Novos Sinistros</v-btn
              >
            </form>
            <!-- <v-btn v-on:click="openSalesForce()" color="info" type="button"><v-icon>check</v-icon>&nbsp; Novos Sinistros</v-btn> -->
          </template>
          <span>Abertura de sinistros após Fev/21</span>
        </v-tooltip>
      </v-flex>
      <v-flex md12>
        <div class="line"></div>
      </v-flex>
    </v-layout>

    <v-layout row class="content-body overflow-y-auto">
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="sinistros"
          :items-per-page="topItems"
          :loading="loading"
          :search="search"
          loading-text="Carregando... Por favor aguarde."
          :no-data-text="noDataText"
          no-results-text="Nenhuma informação encontrada"
          @click="requestTma(item)"
          :sort-by="['dataOcorrencia']"
          :sort-desc="[true]"
          class=""
        >
          <template v-slot:item.dataOcorrencia="{ item }">
            {{ FormatarData(item.dataOcorrencia) }}
          </template>
          <template v-slot:item.cpf="{ item }">
            {{ formatarCpfCnpj(item.cpf) }}
          </template>
          <template v-slot:item.tma="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click="requestTma(item)" v-on="on">mdi-magnify</v-icon>&nbsp;
              </template>
              <span>Clique para ver detalhes do sinistro</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-flex>

      <v-overlay :value="fullLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-dialog v-model="dialog" max-width="1200" max-he>
        <v-card>
          <v-card-title v-if="sinistroSemTMA == true" class="headline"
            >Atenção</v-card-title
          >
          <v-card-text v-if="sinistroSemTMA == true">
            Este sinistro tem data de ocorrência anterior a implementação do
            acompanhamento on-line. Para maiores informações sobre o processo, ligue na
            Central de Atendimento, conforme abaixo:
            <br />
            3003 6773 (Para Capitais e Regiões Metropolitanas)<br />
            0800 709 8059 (Demais Regiões)
            <br /><br />
            Atendimento de segunda a sexta-feira, das 8h às 18h, exceto feriados
            nacionais.
          </v-card-text>
          <v-card-text
            v-if="sinistroSemTMA == false"
            style="overflow: auto; height: 440px"
          >
            <iframe
              :src="urlTMA"
              width="100%"
              height="700"
              frameborder="0"
              scrolling="yes"
              marginheight="0"
              marginwidth="0"
            ></iframe>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="info" @click="dialog = false">
              <v-icon>mdi-close</v-icon> Fechar
              <span v-if="sinistroSemTMA == false">TMA</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Helpers from "@/utilities/Helpers";

export default {
  mixins: [Helpers],

  data() {
    return {
      search: "",
      urlTMA: "",
      dialog: false,
      termoPesquisa: "",
      loading: false,
      fullLoading: false,
      topItems: 10,
      offset: 1,
      options: {},
      headers: [
        { text: "Apólice", value: "apolice", sortable: true },
        {
          text: "Apólice Sem Ponto",
          value: "apoliceSemPonto",
          sortable: false,
          align: " d-none",
        },
        { text: "Ramo", value: "ramo", sortable: true },
        { text: "Segurado", value: "nome", sortable: true },
        { text: "CPF", value: "cpf", sortable: true },
        {
          text: "CPF com ponto",
          value: "cpfComPonto",
          sortable: false,
          align: " d-none",
        },
        { text: "Coberturas", value: "cobertura", sortable: true },
        { text: "Nº Aviso Sinistro ", value: "numeroSequenciaPreaviso", sortable: true },
        { text: "Ocorrência", filterable: true, value: "dataOcorrencia", sortable: true },
        { text: "Detalhes", value: "tma", sortable: false },
      ],
      sinistros: [],
      noDataText: "Nenhuma informação pesquisada",
      sinistroSemTMA: false,

      subject: "",
      samlResponseAvisoSinistro: "",
      urlPostSalesForce: process.env.VUE_APP_SSO_SALES_FORCE,
    };
  },

  methods: {
    requestSinistros() {
      this.loading = true;
      this.fullLoading = true;
      let codigoCorretor = this.usuario.codCorretor;

      let url = "PreAviso/" + codigoCorretor;

      if (this.search != "") url += "/" + this.search.replace("/", "_");

      // Request sinistro
      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          console.log(res.data);
          this.sinistros = res.data;
          if (res.data.length == 0) {
            this.noDataText = "Nenhuma informação encontrada";
          }

          for (let index in this.sinistros) {
            this.sinistros[index].apoliceSemPonto = this.sinistros[index].apolice
              .split(".")
              .join("")
              .split("-")
              .join("");
            this.sinistros[index].cpfComPonto = this.formatarCpfCnpj(
              this.sinistros[index].cpf
            );
          }
          //this.search = "";
          this.loading = false;
          this.fullLoading = false;
        })
        .catch((ex) => {
          console.log(ex);
          this.noDataText = "Nenhuma informação encontrada";
          this.loading = false;
          this.fullLoading = false;
        });
    },

    pesquisar() {
      this.requestSinistros();
    },

    requestTma(item) {
      // Request TMA
      let url = "Sinistro/tma/" + item.numeroSequenciaPreaviso;
      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          console.log("requestTMA");
          console.log(res.data);
          //this.openTma(res.data);
          if (res.data != "") {
            this.sinistroSemTMA = false;
            this.openTma(res.data);
          } else {
            this.sinistroSemTMA = true;
            this.dialog = true;
            //this.showToast("error","Erro!","Algum problema ocorreu na autenticação do TMA.");
          }
        })
        .catch((ex) => {
          console.log(ex);
        });
    },

    openTma(id) {
      this.dialog = true;
      this.urlTMA = "https://fiapp.net/TPR/" + id;
    },

    openSalesForce() {
      //Request Aviso Sinistro
      Vue.prototype.$httpSinistro.post("/", {
        samlResponse: this.samlResponseAvisoSinistro,
      });
    },

    async enviarRequisicao() {
      let request = {
        subject: this.subject,
        tipoPortal: 1,
      };

      let paramsRequestContaContato = {
        tipoPortal: 1, //Aviso Sinistro ou Portal Corretor
        userId: this.usuarioInfo.userId,
        personId: parseInt(this.usuarioInfo.personId),
      };

      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const resultCriacaoContaContato = await Vue.prototype.$httpIdentityServerApi.post(
          "person/createUserContactSF",
          paramsRequestContaContato,
          config
        );
        console.log("resultCriacaoContato", resultCriacaoContaContato);

        if (resultCriacaoContaContato.status === 200) {
          console.log("request", request);

          const resultAvisoSinistro = await Vue.prototype.$httpPortal.post(
            "SAML/getSAMLResponse",
            request
          );

          this.samlResponseAvisoSinistro = resultAvisoSinistro.data.ObjetoRetorno;

          console.log("samlResponse", this.samlResponseAvisoSinistro);
          //document.getElementById('btnLoginAvisoSinistroSF').click();
        }
      } catch (ex) {
        console.log(ex);
      }
    },
  },

  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo", usuarioInfo: "getUsuario" }),
  },

  async created() {
    let cnpjCorretor = localStorage.getItem("cpfCnpj");
    let userCpf = localStorage.getItem("userCpf");
    this.subject = cnpjCorretor + "_" + userCpf;
    this.fullLoading = true;
    await this.enviarRequisicao();
    this.fullLoading = false;
  },
};
</script>
